export default {
  title: 'Notification',
  sendNotification: 'Send Notification',
  subject: 'Subject',
  content: 'Content',
  recipientRefType: 'Recipient Ref Type',
  channel: 'Channel',
  sendType: 'Send Type',
  reschedulePeriodInSecond: 'Reschedule Period In Second',
  sendTime: 'Send Time',
  deadline: 'Deadline',
  sendOneTime: 'Only send one time',
  hour: 'hours',
  minute: 'minutes',
  unRead: 'Unread',
  markAllAsRead: 'Mark all as read.',
  turnOnAlerts: 'Turn on alerts',
  allNotificationsAreNowVisible: 'All notifications are now visible',
  turnOffAlerts: 'Turn off alerts',
  success: 'Success',
  error: 'Error',
  sendNotificationSuccess: 'Send Notification Success',
  noNotifications: 'No notifications',
  sendNotificationError: 'Send Notification Error',
  sendTimeMustBeforeDeadline: 'Send Time Must Before Deadline',
  confirmSCNote: 'Please send the code to the booker to check the information.',
  immediately: 'Immediately',
  workSchedule: 'Schedule',
  Customer: 'Customer',
  entireSystem: 'Entire System',
  company: 'Company',
  addAgency: 'Agency',
  reapply: 'Reapply',
  reapplied: 'Reapplied. Please double-check the information before sending the notification.',
}
